import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isFunction } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
import { calcMultipleSearchInputWidth, includeSeparators, genInputElement } from './utils';
import SubMixin from './mixins/sub';
export default {
  name: buildComponentName('SelectSearchInput'),
  mixins: [SubMixin],
  props: {
    align: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      inputStyle: null
    };
  },
  computed: {
    prefixCls: function prefixCls() {
      return this.rootPrefixCls;
    }
  },
  watch: {
    rootInnerVisible: function rootInnerVisible(nVal) {
      if (nVal) {
        this.focus();
      }
    },
    rootSearchInputValue: function rootSearchInputValue(nVal, oVal) {
      var _this = this;

      var inputMirror = this.$refs.inputMirror,
          align = this.align;

      if (align && inputMirror && nVal !== oVal) {
        this.$nextTick(function () {
          _this.inputStyle = calcMultipleSearchInputWidth(nVal, inputMirror);
        });
      }
    }
  },
  methods: {
    focus: function focus() {
      var inputRef = this.$refs.inputRef;

      if (inputRef) {
        inputRef.focus();
      }
    },
    blur: function blur() {
      var inputRef = this.$refs.inputRef;

      if (inputRef) {
        inputRef.blur();
      }
    },
    onInput: function onInput(e) {
      var rootIsMultiple = this.rootIsMultiple,
          rootTokenSeparators = this.rootTokenSeparators,
          onTokenSeparator = this.onTokenSeparator,
          onSearchInput = this.onSearchInput;
      var value = e.target.value;

      if (rootIsMultiple && rootTokenSeparators.length > 0 && includeSeparators(value, rootTokenSeparators)) {
        onTokenSeparator(value);
        return;
      }

      onSearchInput(e, value);
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        inputStyle = this.inputStyle,
        rootSize = this.rootSize,
        rootDisabled = this.rootDisabled,
        rootIsCombobox = this.rootIsCombobox,
        rootSearchInputValue = this.rootSearchInputValue,
        rootGetInputElement = this.rootGetInputElement,
        onInput = this.onInput;
    var attrs = {
      type: 'text',
      autocomplete: 'off',
      disabled: rootDisabled
    };
    var domProps = {
      value: rootSearchInputValue
    };
    var on = {
      input: onInput
    };
    var inputNode = h("input", _mergeJSXProps([{}, {
      class: _defineProperty({
        'ux-input': rootIsCombobox
      }, "".concat(prefixCls, "-search__field"), true),
      style: inputStyle,
      attrs: attrs,
      domProps: domProps,
      on: on,
      ref: 'inputRef'
    }]));

    if (rootIsCombobox && isFunction(rootGetInputElement)) {
      var input = rootGetInputElement();

      if (input) {
        inputNode = genInputElement(input, {
          class: "".concat(prefixCls, "-search__field"),
          props: {
            value: rootSearchInputValue,
            disabled: rootDisabled,
            size: rootSize
          },
          on: {
            input: onInput
          },
          ref: 'inputRef'
        }); // 强行将 inputRef 元素加入内部的$refs中,目的是在focus/blur时可以使用, 造成的后果是外部设置的ref无效,
        // 如果不这么做, 会在使用allow-clear时出现第一次输入字符时丢失焦点的问题
        // ********************
        // **上面分析的原因是不对的**,导致allow-clear出现第一次输入字符时丢失焦点
        // 原因主要是placeholder元素在input元素之前,
        // 导致输入字符时,placeholder元素消失,而allow-clear元素在底部出现, 进而导致整个selector重新渲染,失去焦点
        // hw 2018.12.11
        // ********************
        // inputNode.context = this;
      }
    }

    return h("span", {
      "class": "".concat(prefixCls, "-search__field__wrap")
    }, [inputNode, h("span", {
      "class": "".concat(prefixCls, "-search__field__mirror"),
      "ref": "inputMirror"
    }, [rootSearchInputValue, "\xA0\xA0"])]);
  }
};